export default __webpack_public_path__ + "static/media/hotspot-inner-white.cc862aae.svg";